import React from 'react'
import Modal from 'components/Modal'
import Button from 'components/Button'
import { ModalInjectedProps } from 'containers/ModalManager'
import {
  UpdateWorkspaceMemberMutationVariables,
  WorkspaceMembershipFragment,
  WorkspaceMinimalFragment,
} from 'gqlTypes'

interface ChangeRoleConfirmationModalProps extends ModalInjectedProps {
  variant: ExtractSafe<
    WorkspaceMinimalFragment['userRole'],
    'ADMIN' | 'FINANCE'
  >
  membershipId: string
  role: UpdateWorkspaceMemberMutationVariables['input']['role']
  updateMember: (options?: {
    variables: UpdateWorkspaceMemberMutationVariables
  }) => void
  loading: boolean
}

export const ChangeRoleConfirmationModal: React.FC<ChangeRoleConfirmationModalProps> = props => {
  const handleConfirm = () => {
    let newRole: WorkspaceMembershipFragment['role']
    if (props.variant === 'ADMIN') {
      newRole = props.role === 'ADMIN' ? 'MEMBER' : 'ADMIN'
    } else {
      newRole = props.role === 'FINANCE' ? 'MEMBER' : 'FINANCE'
    }

    props.updateMember({
      variables: {
        input: {
          membershipIdentifier: props.membershipId,
          role: newRole,
        },
      },
    })
  }

  let title
  let body
  if (props.variant === 'ADMIN') {
    title = 'Change membership type'
    body = (
      <>
        Are you sure you want to change this user to{' '}
        {props.role === 'ADMIN' ? 'Member' : 'Admin'}?
      </>
    )
  } else {
    const isFinance = props.role === 'FINANCE'

    title = `${isFinance ? 'Remove' : 'Make'} Finance`
    body = isFinance
      ? 'Removing Finance role gives this user the permission to browse, inspect, and comment on documents in the web application.'
      : 'Finance role looses the permission to browse, inspect, and comment on documents in the web application.'
  }

  return (
    <Modal title={title} onCancel={props.hideModal}>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>
        <Button disabled={props.loading} onClick={props.hideModal}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          loading={props.loading}
          disabled={props.loading}
          variant="primary">
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
